import React, { useMemo } from 'react'
import LessonItem from './LessonItem'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import LessonItemPending from './LessonItemPending'
const LessonsList = () => {
  const lessonsType = useSelector((state: RootReducer) => state.lessonsReducer.lessonsType)
  const lessons = useSelector((state: RootReducer) => state.lessonsReducer[lessonsType].lessons)
  const lessonsLabel = useMemo(() => {
    if (lessonsType === 'accepted') {
      return 'Upcoming Lessons'
    }
    if (lessonsType === 'pending') {
      return 'Lesson Requests'
    }
    return 'Lesson History'
  }, [lessonsType])

  const LessonItemComponent = useMemo(() => {
    if (lessonsType === 'accepted') {
      return LessonItem
    }
    if (lessonsType === 'pending') {
      return LessonItemPending
    }
    return LessonItem
  }, [lessonsType])
  return (
    <div>
      <div className="font-domine font-bold text-22 text-slateGray">{lessonsLabel}</div>
      <div className="h-2" />
      {lessons.map((lesson) => (
        <React.Fragment key={lesson.id}>
          <LessonItemComponent
            lessonId={lesson.id}
            name={lesson.student_email}
            date={new Date(lesson.starts_at * 1000).toLocaleString()}
          />
          <div className="h-2" />
        </React.Fragment>
      ))}
    </div>
  )
}

export default LessonsList
